import { useMutation } from "@tanstack/react-query";
import { AIAgentDefinitions } from "@graylog/enterprise-api";
const toggleWorkflowStatus = async (workflow) => {
  if (workflow.disabled) {
    await AIAgentDefinitions.enable(workflow.id);
  } else {
    await AIAgentDefinitions.disable(workflow.id);
  }
};
const useToggleWorkflowStatus = () => useMutation({
  mutationFn: toggleWorkflowStatus
});
export default useToggleWorkflowStatus;
